<div class="searchBarInput__cont">
  <app-ds-input-text
    [size]="inputSize"
    [isReadonly]="true"
    [filled]="filled"
    [staticFilled]="staticFilled"
    [icon]="icon"
    [isDisabled]="disabled"
    [label]="labelInput"
    [placeholder]="placeholder"
    [value]="value"
    [isFailed]="isError"
    [failedMessage]="'CHOICE_DATE' | transloco"
    (clickEvent)="isFocusEmit()">
  </app-ds-input-text>
</div>